<script setup lang="ts">
const t2 = useT2({
  'Cookies policy': 'Slapukų politika',
})
const { seller } = useSeller('server')
</script>

<template>
  <AppMenu :title="t2('Cookies policy')">
    <template #content>
      <DocumentUi :document-id="seller?.doc?.cookiePolicy?._id" />
    </template>

    <!-- <AppCookies :modal="false" /> -->
    <div class="m_pl1 m_pr1">
      <LazyAppCookieBotCookies />
    </div>
  </AppMenu>
</template>
